import styled from 'styled-components'

export const SuburbContent = styled.div`
  .readmore-readless {
    margin-bottom: 0;
  }
`
